import map from './map.jpg'
import photo from './photo.jpg'

export { map, photo }



// WEBPACK FOOTER //
// ./src/components/Footer/images/index.js